import { render } from "./Chat.vue?vue&type=template&id=6c6f1ad0&scoped=true&ts=true"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=6c6f1ad0&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6f1ad0"]])

export default __exports__